const RESPONSE_TYPE = 'code';
const STATE = 'admin_ui_state';
const FYERS_AUTH_URL = 'https://api-t1.fyers.in/api/v3/generate-authcode';
const FYERS_TOKEN_URL = 'https://api-t1.fyers.in/api/v3/validate-authcode';

let clientId = null;
let secretKey = null;
let redirectUri = null;
let pin = null;

export function setFyersCredentials(nextClientId, nextSecretKey, nextRedirectUri, nextPin) {
  clientId = nextClientId;
  secretKey = nextSecretKey;
  redirectUri = nextRedirectUri;
  pin = nextPin;

  sessionStorage.setItem('admin_fyers_client_id', nextClientId);
  sessionStorage.setItem('admin_fyers_secret_key', nextSecretKey);
  sessionStorage.setItem('admin_fyers_pin', nextPin);
}

export function generateLoginUrl() {
  if (!clientId || !secretKey || !redirectUri) {
    throw new Error('Fyers credentials not set');
  }

  const params = new URLSearchParams({
    client_id: clientId,
    redirect_uri: redirectUri,
    response_type: RESPONSE_TYPE,
    state: STATE
  });

  return `${FYERS_AUTH_URL}?${params.toString()}`;
}

export function triggerFyersLogin() {
  window.location.href = generateLoginUrl();
}

export function extractAuthCode() {
  const params = new URLSearchParams(window.location.search);
  return params.get('auth_code');
}

export async function generateToken(authCode) {
  clientId = clientId || sessionStorage.getItem('admin_fyers_client_id');
  secretKey = secretKey || sessionStorage.getItem('admin_fyers_secret_key');
  pin = pin || sessionStorage.getItem('admin_fyers_pin');

  if (!authCode) {
    throw new Error('Auth code missing');
  }

  if (!clientId || !secretKey) {
    throw new Error('Fyers credentials missing from session');
  }

  const appIdHash = await generateAppIdHash(clientId, secretKey);

  const response = await fetch(FYERS_TOKEN_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      grant_type: 'authorization_code',
      appIdHash,
      code: authCode
    })
  });

  const tokenResponse = await response.json();

  sessionStorage.removeItem('admin_fyers_client_id');
  sessionStorage.removeItem('admin_fyers_secret_key');
  sessionStorage.removeItem('admin_fyers_pin');

  if (!response.ok) {
    throw new Error(
      tokenResponse.message ||
        tokenResponse.messsage ||
        `Fyers token validation failed with status ${response.status}`
    );
  }

  const tokenPayload = {
    ...tokenResponse,
    pin,
    appIDHash: appIdHash,
    clientID: clientId
  };

  clientId = null;
  secretKey = null;
  redirectUri = null;
  pin = null;

  return tokenPayload;
}

async function generateAppIdHash(appId, appSecretKey) {
  const message = `${appId}:${appSecretKey}`;
  const encoder = new TextEncoder();
  const data = encoder.encode(message);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));

  return hashArray.map((value) => value.toString(16).padStart(2, '0')).join('');
}
